export const appRootElementSelector = '#app'
